__turbopack_context__.v({
  "rect": "index-module-scss-module__1yxcDW__rect",
  "stars": "index-module-scss-module__1yxcDW__stars",
});
